import React, {useState} from "react";
import styled from "styled-components";
import Colors from "../../constants/Colors";
import Accordion from "./Accordion";

type IProps = {
    item?: any;
}

const FaqAccordion = (props: IProps) => {
    const [isActive, setIsActive] = useState(false);

    const [question, setQuestion] = useState();

    const handleQuestion = (e: any) => {
        setQuestion(e.target.value);
    }

    return (
        <React.Fragment>

            <FaqAccordionWrapper key={Math.random()}>
                <div className="faq-accordion-item">
                    <div className="faq-accordion-title"
                         onClick={() => setIsActive(!isActive)}>
                        <div className={"faq-accordion-input"}>
                            <input type={"radio"} id={props.item.title} name={"questions"}
                                   value={props.item.title}
                                   key={props.item.key}
                                   onChange={handleQuestion}
                                   checked={props.item.title === question}
                            />
                            <label htmlFor={props.item.title}>{props.item.title}</label>
                            <span className="checkmark"></span>
                        </div>

                    </div>
                    {isActive &&
                        <div className={'faq-accordion-content'}>
                            {props.item.items.map((item: any) => (
                                <Accordion key={Math.random()} item={item}/>
                            ))}
                        </div>
                    }
                </div>
            </FaqAccordionWrapper>

        </React.Fragment>
    );
}

const FaqAccordionWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 7px;
  }

  .faq-accordion-item {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;

    .faq-accordion-title {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      background: ${Colors.white};
      border-radius: 10px;
      padding: 12px 43px;

      .faq-accordion-input {
        position: relative;
        width: 100%;
        display: block;
        cursor: pointer;
        user-select: none;

        > input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 100%;
          width: 100%;
          margin: 0;
          //z-index: 2;
        }

        > .checkmark {
          position: absolute;
          top: 0;
          left: 0;

          -webkit-appearance: none;
          appearance: none;
          background-color: #fff;
          margin: 0;
          color: ${Colors.blackColor};
          width: 15px;
          height: 15px;
          border: 1px solid ${Colors.blackColor};
          border-radius: 50%;
          transform: translateY(5px);
          display: grid;
          place-content: center;

          &::before {
            content: "";
            display: block;
            width: 9px;
            height: 9px;
            border-radius: 50%;
            transform: scale(0);
            transition: 120ms transform ease-in-out;
            box-shadow: inset 7px 7px ${Colors.brandColor};
            background-color: ${Colors.brandColor};
          }

          &:focus {
            outline: max(2px, 0.15em) solid ${Colors.brandColor};
            outline-offset: max(2px, 0.15em);
          }

          &:checked {
            border: 1px solid ${Colors.brandColor};

            &::before {
              transform: scale(1);
            }
          }
        }

        > label {
          position: relative;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          display: flex;
          align-items: center;
          color: ${Colors.blackColor};
          margin-left: 27px;
          cursor: pointer;
        }

        > input:checked ~ .checkmark {
          border: 1px solid ${Colors.brandColor};
          transition: 120ms transform ease-in-out;
          background-color: unset;

          &::before {
            transform: scale(1);
          }
        }

      }
    }

    .faq-accordion-content {
      position: relative;
      margin-top: 26px;
      margin-bottom: 18px;

      &:last-child {
        margin-bottom: 0;
      }

      .accordion-item {
        position: relative;
        margin-bottom: 0;

        .accordion-title {

          div {
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
      
      .accordion-content {
        p {
            font-size: 16px;
            line-height: 24px;
        }
      }
    }
  }
`;

export default FaqAccordion;
